import { __decorate, __metadata } from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { AppStateActions } from './app.actions';
import * as i0 from "@angular/core";
let AppState = /*#__PURE__*/(() => {
  let AppState = class AppState {
    static connectionError(state) {
      return state.connectionError;
    }
    static chunkError(state) {
      return state.chunkError;
    }
    // isBrowser = isPlatformBrowser(this.platformId)
    constructor() {}
    ngxsOnInit(ctx) {}
    onSetConnectionError({
      patchState
    }, action) {
      patchState({
        connectionError: action.isError
      });
    }
    onSetChunkError({
      patchState
    }, action) {
      patchState({
        chunkError: action.isError
      });
    }
    static {
      this.ɵfac = function AppState_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppState)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AppState,
        factory: AppState.ɵfac
      });
    }
  };
  __decorate([Action(AppStateActions.SetConnectionError), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, AppStateActions.SetConnectionError]), __metadata("design:returntype", void 0)], AppState.prototype, "onSetConnectionError", null);
  __decorate([Action(AppStateActions.SetChunkError), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, AppStateActions.SetConnectionError]), __metadata("design:returntype", void 0)], AppState.prototype, "onSetChunkError", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], AppState, "connectionError", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], AppState, "chunkError", null);
  AppState = __decorate([State({
    name: 'app',
    defaults: {
      connectionError: false,
      chunkError: false
    }
  }), __metadata("design:paramtypes", [])], AppState);
  return AppState;
})();
export { AppState };